export const state = {
  bondtrackings: [],
  systemBondtracking: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/bondtrackings/state.js